<ng-container>

  <div>
    <b>{{ name }}</b>
    <app-info class="formGroupLabel" [wide]="false" [placement]="'left'">
      <div class="tooltipContent">
        <b>Considering</b>
        <ul>
          @for (consider of splitConsidering(); track consider) {
            <div>
              <li>
                {{ consider }}
              </li>
            </div>
          }
        </ul>
      </div>
    </app-info>
  </div>

  <ng-container>
    <div class="row">
      <div class="col-md fieldset">
        <app-visit-exemptions-exemption-common [exemption]="exemption"></app-visit-exemptions-exemption-common>
      </div>
      <div class="col-md fieldset">
        <div class="row">
          <app-form-group label="Penetration Depth Of Spudcans (cm)">
            <input [(ngModel)]="exemption.penetrationDepthOfSpudcans" id="penetrationDepthOfSpudcans" type="number"
                   maxlength="5" class="form-control" required>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Diameter Of Spudcans (cm)">
            <input [(ngModel)]="exemption.diameterOfSpudcans" id="diameterOfSpudcans" type="number"
                   maxlength="5" class="form-control" required>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group>
            <app-info class="formGroupLabel">
              <label>Soil Survey Conducted</label>
              <div class="tooltipContent">Prior to the request, a soil survey must be carried out by the operator to
                determine the presence of culverts, cables, pipes, etc. in the soil.
              </div>
            </app-info>
            <app-yes-no [(ngModel)]="exemption.soilSurveyConducted" id="soilSurveyConducted" required></app-yes-no>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group>
            <app-info class="formGroupLabel">
              <label>Reason for request for exemption</label>
              <div class="tooltipContent">A minimum of 20 characters is required</div>
            </app-info>
            <textarea [(ngModel)]="exemption.reason" id="reason" type="text" rows="3" minlength="20" maxlength="1024"
                      class="form-control" required></textarea>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Details">
            <textarea [(ngModel)]="exemption.details" id="details" type="text" rows="3" maxlength="256"
                      class="form-control"></textarea>
          </app-form-group>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
